const driverEn = {
	driverTable: 'Driver',
	driverEditForm: 'Driver',
	name: 'Name',
	code: 'Code',
	created: 'Created',
	updated: 'Updated',
	type: 'Model type',
	driverLog: 'Driver log',
	endpoint: 'Endpoint',
};

export default driverEn;
